// import { PhoneNumberUtil } from "google-libphonenumber";
// const phoneUtil = PhoneNumberUtil.getInstance();

export type LoginFormValues = {
  email: string;
  password: string;
};

export type UpdateFormValues = {
  firstName: string;
  lastName: string;
};

export type ResetPasswordFormValues = {
  token: string;
  password: string;
  confirmPassword: string;
};

// const todayDate = moment().format('YYYY-MM-DD');

export const validateLoginFunction = (values: LoginFormValues) => {
  let errors: any = {};
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  if (!values.email) {
    errors.email = "Email cannot be blank";
  } else if (!regex.test(values.email)) {
    errors.email = "Invalid email format";
  }
  if (!values.password) {
    errors.password = "Password cannot be blank";
  } else if (values.password.length < 6) {
    errors.password = "Password must be more than 6 characters";
  }
  return errors;
};

export const validateResetPasswordDetails = (
  values: ResetPasswordFormValues
) => {
  let errors: any = {};

  if (!values.token) {
    errors.token = "Reset Token cannot be blank";
  }
  if (!values.password) {
    errors.password = "Password cannot be blank";
  } else if (values.password.length < 6) {
    errors.password = "Password must be more than 6 characters";
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = "Confirm password cannot be blank";
  } else if (values.confirmPassword !== values.password) {
    errors.confirmPassword = "Password don't match";
    errors.password = "Password don't match";
  }
  return errors;
};

// export const validateDetails = (values) => {
//     let errors = {};
//     const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
//     if (!values.email) {
//         errors.email = "Email cannot be blank";
//     } else if (!regex.test(values.email)) {
//         errors.email = "Invalid email format";
//     }
//     if (!values.firstName) {
//         errors.firstName = "First Name cannot be blank";
//     }
//     if (!values.lastName) {
//         errors.lastName = "Last Name cannot be blank";
//     }
//     // if (!values.mobile) {
//     //     errors.mobile = 'Please, enter phone number';
//     // }
//     return errors;
// };


export const validateUpdateDetails = (values: UpdateFormValues) => {
  let errors: any = {};
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

  if (!values.firstName) {
    errors.firstName = "First Name cannot be blank";
  }
  if (!values.lastName) {
    errors.lastName = "Last Name cannot be blank";
  }
};

export const validateDetails = (values: {
  email: string;
  firstName: string;
  lastName: string;
}) => {
  let errors: any = {};
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  if (!values.email) {
    errors.email = "Email cannot be blank";
  } else if (!regex.test(values.email)) {
    errors.email = "Invalid email format";
  }
  if (!values.firstName) {
    errors.firstName = "First Name cannot be blank";
  }
  if (!values.lastName) {
    errors.lastName = "Last Name cannot be blank";
  }
  // if (!values.mobile) {
  //     errors.mobile = 'Please, enter phone number';
  // }
  return errors;
};

export const validateEmail = (values: { email: string }) => {
  let errors: any = {};
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  if (!values.email) {
    errors.email = "Email cannot be blank";
  } else if (!regex.test(values.email)) {
    errors.email = "Invalid email format";
  }
  return errors;
};

export const validateVoucherCode = (values: { voucherCode: string }) => {
  let errors: any = {};
  if (!values.voucherCode) {
    errors.voucherCode = "voucher code cannot be blank";
  }
  return errors;
};

// export const validatePhoneNumber = (mobileObj) => {
//     const { rawMobile, countryCode } = mobileObj;
//     let errorMsg = null;
//     if (!rawMobile) {
//         errorMsg = "Please enter your mobile number";
//         return errorMsg;
//     }
//     const number = phoneUtil.parseAndKeepRawInput(
//         rawMobile,
//         countryCode.toUpperCase()
//     );
//     const isValidNumber = phoneUtil.isValidNumber(number);
//     if (!isValidNumber) {
//         errorMsg = "Please enter a valid mobile number for the selected region";
//         return errorMsg;
//     }
//     const isValidNumberForRegion = phoneUtil.isValidNumberForRegion(
//         number,
//         countryCode.toUpperCase()
//     );
//     if (!isValidNumberForRegion) {
//         errorMsg = "Please enter a valid mobile number for the selected region";
//         return errorMsg;
//     }
//     return errorMsg;
// };
